import React from 'react';
import styles from './index.module.scss';

// Common components are declared here which are specific to address flow
const Header = (props) => {
  const { title, onClose } = props;
  return (
    <div className="d-flex justify-content-between align-items-center">
      <span className={styles['heading']}>{title}</span>
      <span className={styles['close-icon']} onClick={onClose}>
        <i className="fa fa-times-circle"></i>
      </span>
    </div>
  );
};

const RenderAddress = (props) => {
  const { address, onClick = () => {return}, onClickCurrentLocation } = props;
  return(
    <div 
      className={styles['flow-address-container']}
    >
      <div
        onClick={onClick}
        className={`${styles['locality-name-container']} d-flex align-items-center cursor-pointer`}
        style={{ marginRight: onClickCurrentLocation ? 40 : 0 }}
      >
        <i className="fa fa-location-arrow mr-2"></i>
        <div className={styles['locality-name']}>
          {address}
        </div>
        <div className={styles['change-button']}>CHANGE</div>
      </div>
      {onClickCurrentLocation && <div
        style={{ position: 'absolute', right: 0, top: 2, cursor: 'pointer' }}
        className="small font-weight-bold"
        onClick={onClickCurrentLocation}
      >
        <img src='https://ik.imagekit.io/ykmmrc3nwl/gps__1__XYXbC3ZvF.png?tr=h-60,w-60' className={styles['current-location-image']} />
      </div>}
    </div>
  );
};

const CancelButton = (props) => {
  const { onCancel } = props;
  return(
    <div onClick={onCancel}><span style={{ color: '#05e177', cursor: 'pointer' }} className="mr-4 cursor-pointer font-weight-bold">Cancel</span></div>
  );
};

export default Header;
export { RenderAddress, CancelButton };